<template>
  <div :class="[question.StyleClass]">
    <div v-if="question?.ButtonText" class="toggle-question">
      <HomeBaseLabel :question="question" />
      <div class="mt-4">
        <a
          href="#"
          class="text-decoration-none font-weight-medium black2-color font-18"
          :data-uiid="question.DataUiid"
          :aria-label="question?.Text ?? ''"
          @click.prevent="getValue"
        >
          <span class="mr-4">
            <v-icon v-if="question.Value" color="accent" size="40"
              >mdi-minus-circle</v-icon
            >
            <v-icon v-else color="accent" size="40">mdi-plus-circle</v-icon>
          </span>
          <span>
            {{ question.ButtonText }}
          </span>
        </a>
      </div>
    </div>
    <div v-else class="margin-second-applicant">
      <a
        href="#"
        class="text-decoration-none black--text font-weight-medium"
        :data-uiid="question.DataUiid"
        @click.prevent="getValue"
        :aria-label="question?.Text ?? ''"
      >
        <v-icon large color="accent" v-if="question.Value"
          >mdi-minus-circle</v-icon
        >
        <v-icon large color="accent" v-else>mdi-plus-circle</v-icon>
        {{ question.Text }}
      </a>
    </div>
  </div>
</template>

<script>
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapActions } from "vuex";

export default {
  name: "RadioButtonToggleHiddenQuestion.vue",
  components: {
    HomeBaseLabel,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    // Mount the answer value
    // If resuming from API data, the Value is string "true"
    // If coming back from another stage it's bool true
    // Both should count as true
    this.question.Value =
      this.question.Value === "true" || this.question.Value === true;
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, ["setQuestionVisibility"]),
    getValue() {
      this.question.Value = !this.question.Value;
      this.setQuestionVisibility(this.question);
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-size {
  font-size: 40px;
}
.toggle-question {
  padding-bottom: 14px;
}
.margin-second-applicant {
  margin-top: 36px;
  margin-bottom: -2px;
}
</style>
